'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getError = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorInPayload = (0, _getIn2.default)(['payload', 'error']);

var getError = exports.getError = function getError(action) {
  if (action.payload instanceof Error) {
    return action.payload;
  }

  var errorInPayload = getErrorInPayload(action);
  if (errorInPayload instanceof Error) {
    return errorInPayload;
  }

  return null;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/action/operators/getError.js
// module id = 228
// module chunks = 2 3